import { useProperty, useTranslation } from '@eti/providers';
import { TripType } from '@eti/schema-types';
import { useRef } from 'react';
import { change } from 'redux-form';
import AirportList from '../../common/availability-components/AirportList';
import ProductLayout from '../../common/main-layout/ProductLayout';
import { useIllustration } from '../../common/utils/useIllustration';
import { FAST_TRACK } from '../../products';
import { getProduct } from '../../single-choice/utils/singleChoiceTransformer';
import { getPriceProps, getReadMoreLabel, getSingleChoiceProps, getUpsellProps, parseJsonProp } from '../../common/utils/productCardProps';
import getTranslatedTexts from '../../common/text-resolvers/utils/getTranslatedTexts';
import { useProductSnowplowTracking } from '../../custom-hooks/useProductSnowplowTracking';
import AirportAvailability from '../../common/availability-components/AirportAvailability';
import { productCardGrid, readMoreGrid } from '../../common/availability-components/styles';
import { useLinksAccessibility } from '../../custom-hooks/useLinkAccessibility';
import { getAvailabilityList, getCartAvailability, validateAvailabilityTranslation } from './utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = FAST_TRACK;
const texts = {
  readMoreContent: 'fastTrackReadMoreModalContent',
  description: 'fastTrackAbstract',
  title: 'fastTrackTitle',
  upSell: 'fastTrackUpSellText',
  airportAvailability: 'fasttrackGeneralPurpose'
};
const MainFastTrack = _ref => {
  var _productSegmentAvaila;
  let {
    className,
    form,
    isSelected,
    order,
    productSpecificTexts,
    productPosition,
    dispatch,
    tripType
  } = _ref;
  const {
    t,
    nonDebugT
  } = useTranslation();
  const translation = getTranslatedTexts(texts, t);
  const {
    p
  } = useProperty();
  const illustrationUrl = useIllustration(PRODUCT_NAME);
  const product = getProduct(PRODUCT_ID, order, 'none');
  const rootElement = useRef(null);
  const {
    description,
    readMoreContent,
    title,
    airportAvailability
  } = translation;
  useProductSnowplowTracking(PRODUCT_NAME, {
    rootElement,
    productPosition
  });
  useLinksAccessibility({
    targetElement: rootElement,
    productTitle: title
  });
  const isMultiStop = tripType !== TripType.OneWay && tripType !== TripType.Return;
  if (!product) {
    return null;
  }
  const {
    priceRaw
  } = product;
  const availabilityList = getAvailabilityList(order.bounds, (_productSegmentAvaila = productSpecificTexts === null || productSpecificTexts === void 0 ? void 0 : productSpecificTexts.productSegmentAvailabilityTexts) !== null && _productSegmentAvaila !== void 0 ? _productSegmentAvaila : []);
  const availabilityProps = parseJsonProp(airportAvailability);
  const hasAllTranslation = validateAvailabilityTranslation(availabilityProps);
  const shouldDisplayAvailability = availabilityList && availabilityList.length > 0 && hasAllTranslation;
  const {
    upSellObject,
    isUpsellHighlight = false,
    shouldDisplayUpsell = false
  } = getUpsellProps(translation.upSell, {
    shouldDisplayAvailability,
    availabilityList,
    tripType
  });
  const {
    priceLabel,
    price,
    priceSuffix
  } = getPriceProps(t, isSelected, product);
  const readMoreButtonLabel = getReadMoreLabel(t);
  const handleAvailabilitySelection = value => {
    if (!dispatch) {
      return;
    }
    if (value === 'true' && shouldDisplayAvailability) {
      var _order$travelers;
      dispatch(change(form, `${PRODUCT_NAME}.cartBreakDown`, getCartAvailability(order === null || order === void 0 || (_order$travelers = order.travelers) === null || _order$travelers === void 0 ? void 0 : _order$travelers.length, availabilityProps === null || availabilityProps === void 0 ? void 0 : availabilityProps.cart.purchasedMessage, availabilityList)));
    }
  };
  const extraProps = {
    ...getSingleChoiceProps(t, p, nonDebugT),
    availabilityList,
    availabilityTranslation: availabilityProps,
    onButtonChange: handleAvailabilitySelection,
    AirportListComponent: AirportList
  };
  const productData = {
    className,
    description,
    extraProps,
    form,
    illustrationUrl,
    isHighlighted: isUpsellHighlight,
    isSelected,
    price,
    priceLabel,
    priceRaw,
    priceSuffix,
    productId: PRODUCT_ID,
    productName: PRODUCT_NAME,
    productPosition,
    readMoreButtonLabel,
    readMoreContent,
    shouldDisplayUpsell,
    title,
    travelers: order.travelers,
    upSell: upSellObject
  };
  return /*#__PURE__*/_jsxs(ProductLayout, {
    productData: productData,
    ref: rootElement,
    children: [shouldDisplayAvailability && /*#__PURE__*/_jsx(ProductLayout.ReadMore, {
      customGrid: readMoreGrid,
      children: /*#__PURE__*/_jsx(AirportAvailability, {
        isMultiStop: isMultiStop,
        testid: "availability-readmore"
      })
    }), isSelected && shouldDisplayAvailability && /*#__PURE__*/_jsx(AirportAvailability, {
      className: productCardGrid,
      isMultiStop: isMultiStop,
      isSelected: isSelected,
      testid: "availability-purchase"
    })]
  });
};
export default MainFastTrack;
//# sourceMappingURL=MainFastTrack.js.map